import axios from "axios";
import Utils from '../utils/Utils.js';
import Constants from "../../Constants";

export default class BaseService {
    constructor(entity, extraUrl = '', base = Constants.API_BASE_URL) {
        this.entity = entity;
        this.extraUrl = extraUrl;
        this.baseUrl = base;
        axios.defaults.baseURL = this.baseUrl;
        // axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem("auth_token");
    }


    getRequest(parameters = {}) {
        return axios.get(`${this.extraUrl}?${Utils.convertObjToUrlParams(parameters)}`);
    }

    getList(parameters = {}) {
        return axios.get(`${this.entity}${this.extraUrl}?${Utils.convertObjToUrlParams(parameters)}`);
    }

    getAll(parameters = {}) {
        return axios.get(`${this.entity}/getall${this.extraUrl}?${Utils.convertObjToUrlParams(parameters)}`);
    }

    getById(id, parameters = {}) {
        return axios.get(`${this.entity}/${id}${this.extraUrl}?${Utils.convertObjToUrlParams(parameters)}`);
    }

    create(data, parameters = {}) {
        return axios.post(`${this.entity}${this.extraUrl}?${Utils.convertObjToUrlParams(parameters)}`, data);
    }

    update(data, parameters = {}) {
        return axios.put(`${this.entity}${this.extraUrl}?${Utils.convertObjToUrlParams(parameters)}`, data);
    }

    delete(id = '', parameters = {}) {
        return axios.delete(`${this.entity}/${id}${this.extraUrl}?${Utils.convertObjToUrlParams(parameters)}`);
    }

    login(data) {
        return axios.post(`${this.entity}${this.extraUrl}`, data);
    }
}
